import thunk from 'redux-thunk'
import Browser from '../services/Browser'
import { createReducer } from '../reducers'
import { createStore, applyMiddleware } from 'redux'

const middlewares = [thunk]

if (process.env.NODE_ENV !== 'production' && !Browser.isIE()) {
	const { createLogger } = require('redux-logger')
	const logger = createLogger()
	middlewares.push(logger)
}

/**
 * The state three
 */
const store = createStore(createReducer(), applyMiddleware(...middlewares))
store.async = {}

export default store
